import React, { useCallback, useEffect, useMemo } from "react";
import AppSideBar from "../AppSideBar";
import {
  StyledMobileMenu,
  StyledMobileMenuDrawer,
  StyledMobileMenuFloatButton,
  StyledMobileMenuItem,
  StyledMobileMenuRow,
} from "./index.styled";
import PropTypes from "prop-types";
import { IoClose } from "react-icons/io5";
import { useCommon, useMainStore } from "_hooks";
import { useLocation } from "react-router-dom";
import { AppAnimateWhileTap } from "_lib/AppAnimate";
import { getIsTradeRoute } from "_helpers";

const AppMobileMenu = (props) => {
  const { routesConfig = [] } = props;

  const {
    main: { mobileMenuOpen },
    setMobileMenuOpen,
  } = useMainStore();

  const { pathname } = useLocation();
  const { onRedirect } = useCommon();

  useEffect(() => {
    if (mobileMenuOpen) {
      setMobileMenuOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const onClickClose = useCallback(() => {
    setMobileMenuOpen(false);
  }, [setMobileMenuOpen]);

  const _routeConfig = useMemo(() => {
    return routesConfig.filter(({ isMobileMenuRoute }) => isMobileMenuRoute);
  }, [routesConfig]);

  const hideMobileMenu = useMemo(() => {
    return getIsTradeRoute(pathname);
  }, [pathname]);

  return (
    <>
      {!hideMobileMenu && (
        <StyledMobileMenu>
          <StyledMobileMenuRow align="center" justify="space-around">
            {_routeConfig.map((route) => {
              const isActive = pathname === route.path;
              return (
                <AppAnimateWhileTap
                  fullHeight
                  key={route.path || route.key}
                  onClick={onRedirect(route.path)}
                >
                  <StyledMobileMenuItem active={`${isActive}`}>
                    {route.icon}
                    <span> {route.mobileTitle || route.title}</span>
                  </StyledMobileMenuItem>
                </AppAnimateWhileTap>
              );
            })}
          </StyledMobileMenuRow>
        </StyledMobileMenu>
      )}

      <StyledMobileMenuDrawer
        open={mobileMenuOpen}
        height="100%"
        width="100%"
        placement="left"
        closable={true}
        destroyOnClose={true}
      >
        <StyledMobileMenuFloatButton
          type="primary"
          icon={<IoClose />}
          onClick={onClickClose}
        />

        <AppSideBar routesConfig={routesConfig} />
      </StyledMobileMenuDrawer>
    </>
  );
};

AppMobileMenu.propTypes = {
  routesConfig: PropTypes.array,
};

export default AppMobileMenu;
